<template>
    <div class="x_box A4">
        <div class="x_body">
            <template v-if="headerType==3">
                <div class="print-header" style="display: flex;">
                    <div>
                        <img src="/img/no-logo.png" width="130px">
                    </div>
                    <div class="text-center" style="line-height: 24px; margin-left: 250px;">
                        <div class="font-m" style="font-size: 16px; font-weight: bold;">ប័ណ្ណប្រគល់ទំនិញ</div>
                        <div style="font-size: 16px; font-weight: bold;">DELIVERY NOTE</div>
                    </div>
                </div>
            </template>
            <template v-else-if="headerType==4">
                <div class="print-header" style="display: flex;">
                    <div>
                        <img src="/img/no-logo.png" width="130px">
                    </div>
                    <div class="text-center" style="line-height: 24px; margin-left: 250px;">
                        <div class="font-m" style="font-size: 16px; font-weight: bold;">ប័ណ្ណប្រគល់ទំនិញ</div>
                        <div style="font-size: 16px; font-weight: bold;">DELIVERY NOTE</div>
                    </div>
                </div>
            </template>
            <template v-else>
                <div class="print-header" style="display: flex; margin-left: 25px;">
                    <div>
                        <img src="/img/no-logo.png" alt="">
                    </div>
                    <div>
                        <h2 class="text-center" style="font-weight: bold;">{{company.Name}}</h2>
                        <h2 class="text-center" style="font-weight: bold;">{{company.LatinName}}</h2>
                        <div style="font-size: 14px;">
                            <b>{{$t('address')}}៖ </b>
                            {{$t('home_no')}} {{company.Home}} {{$t('village')}} {{company.Village}} {{$t('commune')}} {{company.Commune}} {{$t('district')}} {{company.District}} {{$t('capital')}} {{company.Capital}}
                        </div>
                        <div style="font-size: 13px;">
                            <b>{{$t('phone_contact')}}</b>
                            {{company.Phone}} <span>{{$t('email')}}</span>: {{company.Email}}
                            <br>
                            លេខអត្តសញ្ញាណកម្មសារពើពន្ធ​អតប (VAT): {{company.TinHead}}-{{company.VatTin}}
                        </div>
                    </div>
                </div>
                <div style="height: 2px; border: 1px solid black; width: 100%; background: black; margin-bottom: 20px"></div>
                <div class="row">
                    <div class="col-sm-12">
                        <div class="text-center" style="line-height: 24px;">
                            <div class="font-m" style="font-size: 16px; font-weight: bold;">ប័ណ្ណប្រគល់ទំនិញ</div>
                            <div style="font-size: 16px; font-weight: bold;">DELIVERY NOTE</div>
                        </div>
                    </div>
                </div>
            </template>
            <div class="row">
                <div class="col-sm-12">
                    <div style="font-size: 14px;">
                        <div class="row">
                            <div class="col-sm-6">
                                <table class="table-print">
                                    <tbody>
                                        <tr>
                                            <td class="v-top" style="width: 190px;">
                                                កាលបរិច្ឆេទ / <span style="font-size: 14px;">Date</span>
                                            </td>
                                            <td class="v-top" style="width: 10px;">៖</td>
                                            <td class="v-top">{{$format(stockin.OutDateAt, 'DD/MM/YYYY')}}</td>
                                        </tr>
                                        <tr>
                                            <td class="v-top">
                                                ឈ្មោះអតិថិជន /
                                                <span style="font-size: 14px;">Customer name</span>
                                            </td>
                                            <td class="v-top">៖</td>
                                            <td class="v-top">{{customer.Name}}</td>
                                        </tr>
                                        <tr v-if="addresss != null">
                                            <td class="v-top">សាខា / Branch</td>
                                            <td class="v-top">៖</td>
                                            <td>{{addresss.Name}}</td>
                                        </tr>
                                        <tr>
                                            <td class="v-top">
                                                អាសយដ្ឋាន / <span style="font-size: 14px;">Address</span>
                                            </td>
                                            <td class="v-top">៖</td>
                                            <td class="v-top">{{addresss != null?addresss.Address:customer.Address}}</td>
                                        </tr>
                                        <tr>
                                            <td class="v-top">
                                                លេខទូរស័ព្ទ / <span style="font-size: 14px;">Tel</span>
                                            </td>
                                            <td class="v-top">៖</td>
                                            <td class="v-top">{{customer.Phone}}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div class="col-sm-6">
                                <table class="table-print" align="right">
                                    <tbody>
                                        <tr>
                                            <td class="v-top">
                                                លេខកូដប័ណ្ណ /
                                                <span style="font-size: 14px;">Delivery No</span>
                                            </td>
                                            <td class="v-top" style="width: 15px;">៖</td>
                                            <td class="v-top" style="width: 120px;">{{stockin.Num}}</td>
                                        </tr>
                                        <tr>
                                            <td class="v-top">
                                                លេខបញ្ជាទិញ /
                                                <span style="font-size: 14px;">PO Number</span>
                                            </td>
                                            <td class="v-top" style="width: 15px;">៖</td>
                                            <td class="v-top">{{stockin.DocSourceNo}}</td>
                                        </tr>
                                        <tr>
                                            <td class="v-top">
                                                ឈ្មោះអ្នកបើកបរ /
                                                <span style="font-size: 14px;">Driver Name</span>
                                            </td>
                                            <td class="v-top" style="width: 15px;">៖</td>
                                            <td class="v-top">{{driver.KhmerName}}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <br/>
            <div class="row">
                <div class="col-sm-12">
                    <table class="table table-bordered table-sm">
                        <thead>
                            <tr>
                                <th class="text-center" style="width: 35px; font-size: 14px;">
                                    <span>ល.រ</span><br>
                                    <span style="font-size: 12px;">No.</span>
                                </th>
                                <th class="text-center" style="width: 100px;">
                                    <span>លេខកូដទំនិញ</span><br>
                                    <span style="font-size: 12px;">Item Code</span>
                                </th>
                                <th class="text-center">
                                    ឈ្មោះមុខទំនិញ <br>
                                    <span style="font-size: 12px;">Name of Goods</span>
                                </th> 
                                <th class="text-center" style="width: 100px;">
                                    <span>ចំនួន</span><br>
                                    <span style="font-size: 12px;">Quantity</span>
                                </th>
                                <th class="text-center" style="width: 100px;">
                                    <span>ចំនួនគីឡូសរុប</span><br>
                                    <span style="font-size: 12px;">Total Weight</span>
                                </th>
                                <th class="text-center" style="width: 100px;">
                                    <span>ចំនួនខូចសរុប</span><br>
                                    <span style="font-size: 12px;">Total Damage</span>
                                </th>
                                <th class="text-center" style="width: 100px;">
                                    <span>ចំនួនទទួលបាន</span><br>
                                    <span style="font-size: 12px;">Total Received</span>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(ret, index) in lines" :key="index">
                                <td class="text-center">{{index + 1}}</td>
                                <td class="text-center">{{ret.ItemCode}}</td>
                                <td>{{ret.ItemName}}</td>
                                <td class="text-center">{{ret.QuantityOut}} {{ret.UomName}}</td>
                                <td class="text-center">{{ret.TotalWeight}}</td>
                                <td class="text-center">{{ret.QtyDamaged}}</td>
                                <td class="text-center">{{ret.QtyReceived}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <br>
            <div class="row">
                <div class="col-sm-12">
                    <div style="padding: 10px;">
                        <div class="flex-container flex-x">
                            <div class="text-center">
                                <div>រៀបរៀងដោយ</div>
                                <div>Prepared By</div>
                                <div style="margin-top: 105px;">
                                    <div>ឈ្មោះ និងហត្ថលេខា</div>
                                    <div>Name & Sign</div>
                                </div>
                            </div>
                            <div class="text-center">
                                <div>អ្នកកាន់ស្តុក</div>
                                <div>Stock Supervisor</div>
                                <div style="margin-top: 105px;">
                                    <div>ឈ្មោះ និងហត្ថលេខា</div>
                                    <div>Name & Sign</div>
                                </div>
                            </div>
                            <div class="text-center">
                                <div>ប្រគល់ដោយ</div>
                                <div>Released By</div>
                                <div style="margin-top: 105px;">
                                    <div>ឈ្មោះ និងហត្ថលេខា</div>
                                    <div>Name & Sign</div>
                                </div>
                            </div>
                            <div class="text-center">
                                <div>អ្នកទទួលតំណាងដោយអតិថិជន</div>
                                <div>Customer & Representation</div>
                                <div style="margin-top: 105px;">
                                    <div>ឈ្មោះ និងហត្ថលេខា</div>
                                    <div>Name & Sign</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                company: {},
                customer: {},
                driver: {},
                stockin: {},
                lines: [],
                branch: {},
                addresss: null,
                employee: {
                    KhmerName: ''
                },
                logo: '/img/company-logo.png'
            }
        },
        created() {
            this.getCompany();
            var id = this.$route.params.id;
            if(id != undefined && id != null && id != ''){
                this.findById(id);
            }
        },
        methods: {
            getCompany: function() {
                this.$api().post("company").then(res => {
                    this.company = res.data.Data;
                });
            },
            findById(id){
                var loading = this.$loading.show();
                this.$api().post('stockout/find', { Id: id }).then(res => {
                    if(this.$isValid(res)){
                        var data = res.data.Data;
                        this.stockin = data.StockOut;
                        if(res.data.Json.Customer != null)
                            this.customer = res.data.Json.Customer;
                        if(res.data.Json.Driver != null)
                            this.driver = res.data.Json.Driver;
                        this.branch = data.Branch;
                        if(data.Employee != null)
                            this.employee = data.Employee;
                        this.lines = data.StockOutLines;
                        this.addresss = data.CustomerAddress;
                    }
                }).finally(function() { loading.hide(); });
            }
        },
        computed: {
            headerType(){
                return this.$route.query.type;
            }
        }
    }
</script>
<style scoped>
    .flex-space{
        justify-content: space-between;
    }
    .flex-x{
        justify-content: space-around;
    }
    .v-top{
        vertical-align: top;
    }
    @media print{
        .table-bordered th, .table-bordered td {
            border: 1px solid black;
        }
    }
</style>